const initialState = {
  fetched: false,
  data: null,
  withdrawalSources: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'TAX_STRATEGY_WITHDRAWAL_SOURCES_FETCHED':
      if (action.payload) {
        return Object.assign({}, state, {
          withdrawalSources: action.payload.data,
        });
      } else {
        return state;
      }
    default:
      return state;
  }
};
